<template>
  <LayoutHeader main="password" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article v-if="me">
      <form @submit.prevent="submit()" v-if="step == 'input'">
        <h1 class="text-center mb-4">{{ me.password ? 'パスワードの変更' : 'パスワードの登録' }}</h1>

        <div class="mb-3" v-if="me.password">
          <label for="password" class="form-label fw-bold">現在のパスワード</label>
          <input :type="passwordBeforeType" class="form-control" :class="{'is-invalid': passwordChangeError}" id="passwordBefore" ref="passwordBefore" v-model="passwordBefore" placeholder="8文字以上を入力" autocomplete="new-password" minlength="8" @focus="passwordBeforeFocus()" @blur="passwordBeforeBlur()" required autofocus />
          <div class="invalid-feedback">
            現在のパスワードが違います。
          </div>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label fw-bold">{{ me.password ? '新しい' : '登録する' }}パスワード</label>
          <input :type="passwordAfterType" class="form-control" id="passwordAfter" ref="passwordAfter" v-model="passwordAfter" placeholder="8文字以上を入力" autocomplete="new-password" minlength="8" @focus="passwordAfterFocus()" @blur="passwordAfterBlur()" required />
        </div>
        <div class="mb-5">
          <button type="submit" class="btn btn-danger w-100 fw-bold">{{ me.password ? '変更する' : '登録する' }}</button>
        </div>
        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
        </div>
      </form>
      <div v-else-if="step == 'submited'">
        <h1 class="text-center mb-3">パスワードの{{ me.password ? '変更' : '登録' }}が完了しました</h1>

        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Account' }">戻る</router-link>
        </div>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'パスワードの変更',
      step: this.$route.query.step ?? 'input',
      passwordBefore: '',
      passwordBeforeType: '',
      passwordAfter: '',
      passwordAfterType: '',
      passwordChangeError: false,
    }
  },
  methods: {
    submit() {
      const data = {};
      data.passwordBefore = this.passwordBefore;
      data.passwordAfter = this.passwordAfter;
      this.passwordChangeError = false;
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/password',
        data: data,
      }).then(async (r) => {
        this.loadingOverlay = false;
        if (r.data.error) {
          this.passwordChangeError = true;
          return;
        }
        this.step = 'submited';
      }).catch((e) => {
        alert('error');
        console.log(e);
        this.loadingOverlay = false;
      });
    },
    passwordBeforeFocus() {
      this.passwordBeforeType = 'text';
    },
    passwordBeforeBlur() {
      this.passwordBeforeType = 'password';
    },
    passwordAfterFocus() {
      this.passwordAfterType = 'text';
    },
    passwordAfterBlur() {
      this.passwordAfterType = 'password';
    },
  },
}
</script>



